






























































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { namespace, Getter } from 'vuex-class';
import { Getters } from '@/stores/enquiries/getter-constants';
import { Mutations } from '@/stores/enquiries/mutation-constants';
import { DateTime } from 'luxon';
import { Approval } from '@/models/approval';
import { dateParse } from '@/date-picker-parser';
import loading from '@/components/loading.vue';
import approvalStatusLabel from '@/components/approval-status-label.vue';
import { Permissions } from '@/models/permission-constants';
import QuoteQuickViewModal from '@/components/quote-quick-view-modal.vue';

const ApprovalModule = namespace('approval');
const UserModule = namespace('user');

@Component({
    components: {
        loading,
        approvalStatusLabel,
        QuoteQuickViewModal,
    },
})
export default class ApprovalList extends Vue {
    @Prop({ required: true }) public approvals: Array<Approval>;
    @Prop({ type: Number, default: 1 }) public totalPages: number;
    @Prop({ type: Number, default: 1 }) public page: number;
    @Prop({ type: Number, default: 1 }) public pageSize: number;
    @Prop({ type: Number, default: 1 }) public total: number;
    @Prop({ type: [Number, String] }) public status: number | string;
    @Prop({ type: Boolean, default: false }) public isLoading: boolean;
    @Prop({ type: Boolean, default: false }) public showCreator: boolean;
    @Prop({ type: Boolean, default: false }) public showActions: boolean;
    @Prop({ type: String }) public from: string | null;
    @Prop({ type: String }) public to: string | null;
    @UserModule.Getter public canViewQuotes: boolean;
    @UserModule.Getter public canViewApprovals: boolean;

    private showQuoteQuickViewModal: boolean = false;
    private selectedQuoteId: string | null = null;

    public handleQuoteQuickViewModalVisiblityChange(show: boolean): void {
        if (!show) {
            this.selectedQuoteId = null;
        }

        this.showQuoteQuickViewModal = show;
    }

    public openQuoteQuickView(quoteId: string) {
        this.selectedQuoteId = quoteId;
        this.handleQuoteQuickViewModalVisiblityChange(true);
    }

    public currentStatus: number | string | null = this.status;
    public currentPage: number = this.page;
    public currentFrom: string | null = (this.from ? DateTime.fromFormat(this.from, 'yyyy-MM-dd').toLocaleString() : this.from) || null;
    public currentTo: string | null = (this.to ? DateTime.fromFormat(this.to, 'yyyy-MM-dd').toLocaleString() : this.to) || null;

    public get paginationDescription(): string {
        const start = (this.approvals.length < 1)
            ? 0
            : ((this.currentPage - 1) * this.pageSize) + 1;

        const end = start + this.pageSize > this.total
            ? this.total
            : start + this.pageSize;

        return `Showing ${start.toLocaleString()} - ${end.toLocaleString()} of ${this.total.toLocaleString()}`;
    }

    public parseDate = dateParse;

    @Watch('currentStatus')
    public currentStatusChanged(value: number | string | null): void {
        this.$emit('status-changed', value);
    }
    @Watch('currentPage')
    public currentPageChanged(value: number): void {
        this.$emit('page-changed', value);
    }
    @Watch('currentFrom')
    public currentFromDateChanged(value: string): void {
        // NOTE(Dan): The date for the control is formatted in dd/MM/yyyy,
        //            this needs to be converted to an ISO format
        if (value) {
            value = DateTime.fromFormat(value, 'dd/MM/yyyy').toISODate();
        }

        this.$emit('from-date-changed', value);
    }
    @Watch('currentTo')
    public currentToDateChanged(value: string | null): void {
        // NOTE(Dan): The date for the control is formatted in dd/MM/yyyy,
        //            this needs to be converted to an ISO format
        if (value) {
            value = DateTime.fromFormat(value, 'dd/MM/yyyy').toISODate();
        }

        this.$emit('to-date-changed', value);
    }
}
